import $ from 'jquery';
import Flickity from 'flickity';

// This is required to fix an iOS10 bug for Flickity.
// It is our own implementation of the Flickity 2.0 fix found here: http://bit.ly/2kU4mKW
$(window).on('dragStart', (event) => {
  const $target = $(event.target);
  const $flickityEnabledEl = $target.closest('.flickity-enabled');

  if ($flickityEnabledEl.length) {
    const flickity = Flickity.data($flickityEnabledEl[0]);

    window.removeEventListener('scroll', flickity);
  }
});
